/* esm.sh - nostr-tools@2.23.3/nip19 */
export * from "/*nostr-tools@2.23.3/esnext/nip19.mjs";
